import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { upperFirst } from "lodash";

import uuid from 'uuid/v4';
import PropTypes from 'prop-types';
import cacPalette from '../../corrCluster/enhancedFeatures/cacPalette';

import { saveTrackingData } from '../../../util/trackerUtils';
import { CLUSTER_CORRESPONDENCE_MODULE } from '../../../constants';
import { CAC_CHANGE_NODE_MAP_COLOR } from '../../../trackerConstants';
import { useSelector } from '../react-redux-hooks';



const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: 'white',
    color: 'black',
    boxShadow: theme.shadows[1],
    maxWidth: 200,
    fontSize: 10,
    fontFamily: 'inherit',
    padding: 2,
  },
}))(Tooltip);

const EditToolPalette = ({ title, colorName, nodeColorClick }) => {
  
const { userId, activeAccountId, cacStudy, state } = useSelector(state => ({
  userId: state.login.loginResponse.data.userId,
  activeAccountId: state.account.activeAccountId,
  cacStudy: state.study.cacStudy,
  state,
}));



  const callSaveTrackerFn = ({ action, attributes = undefined }) => {
    saveTrackingData({
      uid: userId,
      accid: activeAccountId,
      productNo: cacStudy && cacStudy.pn,
      moduleName: CLUSTER_CORRESPONDENCE_MODULE,
      attributes,
      action,
    });
  };

  // useEffect(() => {
  //     setTimeout(() => {
  //       callSaveTrackerFn({
  //         action: 'EDIT_TOOL_PALETTE',
  //         attributes: {title, colorName },
  //       });
  //     }, 1000);
  // }, [])

  const handleNCClick = (title, c) => {
      callSaveTrackerFn({
        action: CAC_CHANGE_NODE_MAP_COLOR,
        attributes: { title, colorName: c },
      });
  nodeColorClick(title, c);
  }

  const buildButtons = () => {
    return cacPalette()
      .filter(x => x.use === 'rc')
      .map(c => (
        <HtmlTooltip title={<span>{upperFirst(c.name)}</span>} placement="bottom-end">
          <span
            key={uuid()}
            className="color-picker"
            style={{
              backgroundColor: `${c.light}`,
              color: 'white',
              display: 'flex',
              justifyContent: 'center',
              cursor: 'context-menu',
            }}
            onClick={() => handleNCClick(title, c)}
          >
            {colorName === c.name ? <span>&#10004;</span> : ''}
          </span>
        </HtmlTooltip>
      ));
  };

  return (
    <div
      style={{
        height: '50px',
        width: '200px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          textTransform: 'uppercase',
          font: 'Lato',
          weight: '400',
          lineHeight: '12px',
          letterSpacing: '1.5px',
          fontSize: '10px',
          paddingLeft: '5px',
          width: '150px',
        }}
      >
        Data Point Color
      </div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        {buildButtons()}
      </div>
    </div>
  );
};

export default EditToolPalette;

EditToolPalette.propTypes = {
  colorName: PropTypes.string,
  title: PropTypes.string,
  nodeColorClick: PropTypes.func,
};  
